module.exports = __webpack_public_path__ + "static/media/medium-lg-1.fed805c5.jpg";